import PropTypes from 'prop-types';

const Input = ({ label, error, icon: Icon = null, id, ...props }) => (
  <div>
    {label && (
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: '0.75rem',
          fontWeight: 600,
          color: '#6b7280',
          marginBottom: '4px',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
        }}
      >
        {label}
      </label>
    )}
    <div style={{ position: 'relative' }}>
      {Icon && (
        <Icon
          size={16}
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#9ca3af',
          }}
        />
      )}
      <input
        id={id}
        style={{
          width: '100%',
          padding: Icon ? '8px 12px 8px 34px' : '8px 12px',
          border: error ? '1px solid #fca5a5' : '1px solid #d1d5db',
          borderRadius: '8px',
          fontSize: '0.8rem',
          backgroundColor: error ? '#fef2f2' : '#fff',
          color: '#111827',
          outline: 'none',
          transition: 'border-color 0.15s, box-shadow 0.15s',
          boxSizing: 'border-box',
        }}
        {...props}
      />
    </div>
    {error && (
      <p style={{ fontSize: '0.7rem', color: '#dc2626', marginTop: '2px', marginBottom: 0 }}>{error}</p>
    )}
  </div>
);

Input.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.elementType,
  id: PropTypes.string,
};

export default Input;
